import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import CustomField from "../../../../model/customField/CustomField";
import CreateCustomFieldForm from "../form/create/CreateCustomFieldForm";

interface IComponentProps {
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Create custom field.
	 * @param {CustomField} customField
	 * @param {void} onActionFinish
	 */
	createCustomField: (customField: CustomField, onActionFinish: () => void) => void;
}

export default class CreateCustomFieldModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Create custom field"} fixedWidth>
				<CreateCustomFieldForm createCustomField={this.props.createCustomField}
									   onCancel={this.props.onCancel}/>
			</Modal>
		);
	}
}
